"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formatter_1 = require("../date/formatter");
var events_1 = require("../types/enums/events");
var RsvpCollectionConfig_1 = require("../types/enums/RsvpCollectionConfig");
exports.getEventId = function (event) { return event.id; };
exports.getSlug = function (event) { return event.slug; };
exports.isTicketed = function (event) { return event.registration.type === events_1.EventType.TICKETS; };
exports.isRsvp = function (event) { return !exports.isTicketed(event); };
exports.isScheduled = function (event) { return event.status === events_1.EventStatus.SCHEDULED; };
exports.isPastOrCanceled = function (event) { return exports.isEnded(event) || exports.isCanceled(event); };
exports.isStarted = function (event) { return event.status === events_1.EventStatus.STARTED; };
exports.isEnded = function (event) { return event.status === events_1.EventStatus.ENDED; };
exports.isCanceled = function (event) { return event.status === events_1.EventStatus.CANCELED; };
exports.isActive = function (event) { return !exports.isEnded(event) && !exports.isCanceled(event); };
exports.isRegistrationAutomaticallyClosed = function (event) {
    return event.registration.status === events_1.RegistrationStatus.CLOSED;
};
exports.isRegistrationManuallyClosed = function (event) {
    return event.registration.status === events_1.RegistrationStatus.CLOSED_MANUALLY;
};
exports.isRegistrationExternal = function (event) {
    return event.registration.status === events_1.RegistrationStatus.OPEN_EXTERNAL;
};
exports.isWaitlistOpen = function (event) {
    return event.registration.status === events_1.RegistrationStatus.OPEN_RSVP_WAITLIST;
};
exports.isWaitlistEnabled = function (event) { return event.registration.rsvpCollection.config.waitlist; };
exports.isDateTbd = function (event) { return event.scheduling.config.scheduleTbd; };
exports.isEmpty = function (event) {
    return exports.isTicketed(event) ? !event.dashboard.ticketingSummary.tickets : !event.dashboard.rsvpSummary.total;
};
exports.isFull = function (event) {
    return exports.isScheduled(event) && (exports.isRegistrationAutomaticallyClosed(event) || exports.isWaitlistOpen(event));
};
exports.isLocationTbd = function (event) { return !event.location.address; };
exports.getFormattedLocation = function (event) { return event.location.name || event.location.address; };
exports.getFormattedFullLocation = function (event) {
    if (event.location.address && event.location.name) {
        return event.location.name + ", " + event.location.address;
    }
    return exports.getFormattedLocation(event);
};
exports.getOrdersCount = function (_a) {
    var dashboard = _a.dashboard;
    var _b, _c;
    return _c = (_b = dashboard.ticketingSummary) === null || _b === void 0 ? void 0 : _b.orders, (_c !== null && _c !== void 0 ? _c : 0);
};
exports.getRSVPCount = function (_a) {
    var dashboard = _a.dashboard;
    var _b, _c;
    return _c = (_b = dashboard.rsvpSummary) === null || _b === void 0 ? void 0 : _b.total, (_c !== null && _c !== void 0 ? _c : 0);
};
exports.hasRSVPs = function (event) { return !!exports.getRSVPCount(event); };
exports.getTicketsCount = function (_a) {
    var dashboard = _a.dashboard;
    var _b, _c;
    return _c = (_b = dashboard.ticketingSummary) === null || _b === void 0 ? void 0 : _b.tickets, (_c !== null && _c !== void 0 ? _c : 0);
};
exports.hasTickets = function (event) { return !!exports.getTicketsCount(event); };
exports.hasImage = function (event) { var _a; return !!((_a = event.mainImage) === null || _a === void 0 ? void 0 : _a.id); };
exports.getRestrictedTo = function (event) {
    return event.registration.restrictedTo || events_1.VisitorType.VISITOR;
};
exports.getExternalLink = function (event) { var _a, _b; return _b = (_a = event.registration.external) === null || _a === void 0 ? void 0 : _a.registration, (_b !== null && _b !== void 0 ? _b : null); };
exports.getGuestLimit = function (event) { var _a, _b; return _b = (_a = event.registration.rsvpCollection) === null || _a === void 0 ? void 0 : _a.config.limit, (_b !== null && _b !== void 0 ? _b : null); };
exports.getRsvpStatus = function (event) { var _a; return (_a = event.registration.rsvpCollection) === null || _a === void 0 ? void 0 : _a.config.rsvpStatusOptions; };
exports.getCurrency = function (event) { return event.registration.ticketing.currency; };
exports.isCurrencySet = function (event) { return !!exports.getCurrency(event); };
exports.isCurrencyLocked = function (event) { return event.dashboard.ticketingSummary.currencyLocked; };
exports.isAssignedTickets = function (event) { var _a, _b, _c; return !!((_c = (_b = (_a = event.registration) === null || _a === void 0 ? void 0 : _a.ticketing) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.guestAssignedTickets); };
exports.getTaxConfig = function (event) { var _a, _b, _c, _d; return _d = (_c = (_b = (_a = event.registration) === null || _a === void 0 ? void 0 : _a.ticketing) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.taxConfig, (_d !== null && _d !== void 0 ? _d : null); };
exports.isTaxIncluded = function (event) { var _a, _b, _c; return ((_c = (_b = (_a = event.registration) === null || _a === void 0 ? void 0 : _a.ticketing) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.taxConfig.type) === events_1.TaxType.INCLUDED; };
exports.isEventExternalRegistration = function (event) {
    return event.registration.status === events_1.RegistrationStatus.OPEN_EXTERNAL;
};
exports.isNoResponseEnabled = function (event) {
    return event.registration.rsvpCollection.config.rsvpStatusOptions === RsvpCollectionConfig_1.RsvpStatusOptions.YES_AND_NO;
};
exports.getTitle = function (event) { return event.title; };
exports.getTimeZoneId = function (event) {
    return (!exports.isDateTbd(event) && event.scheduling.config.timeZoneId) || 'UTC';
};
exports.getStartDate = function (event) { return event.scheduling.config.startDate; };
exports.getFormattedStartDate = function (event, fullLocale) {
    var _a = event.scheduling.config, scheduleTbdMessage = _a.scheduleTbdMessage, scheduleTbd = _a.scheduleTbd, startDate = _a.startDate, timeZoneId = _a.timeZoneId, showTimeZone = _a.showTimeZone;
    if (scheduleTbd) {
        return scheduleTbdMessage;
    }
    var showYear = !formatter_1.isYearHidden(formatter_1.getMomentDate(startDate, timeZoneId), undefined);
    return formatter_1.getFullDate(startDate, timeZoneId, showYear, fullLocale, showTimeZone);
};
exports.getFormattedShortStartDate = function (event, fullLocale) {
    var _a = event.scheduling.config, scheduleTbdMessage = _a.scheduleTbdMessage, scheduleTbd = _a.scheduleTbd, startDate = _a.startDate, timeZoneId = _a.timeZoneId;
    if (scheduleTbd) {
        return scheduleTbdMessage;
    }
    return formatter_1.getShortDate(startDate, timeZoneId, fullLocale);
};
exports.getFormattedStartTime = function (event, fullLocale) {
    var config = event.scheduling.config;
    return formatter_1.getTime(config.startDate, config.timeZoneId, fullLocale);
};
exports.getFormattedFullDate = function (event, fullLocale) {
    var _a = event.scheduling.config, scheduleTbd = _a.scheduleTbd, scheduleTbdMessage = _a.scheduleTbdMessage, startDate = _a.startDate, endDate = _a.endDate, endDateHidden = _a.endDateHidden, timeZoneId = _a.timeZoneId, showTimeZone = _a.showTimeZone;
    return scheduleTbd
        ? scheduleTbdMessage
        : formatter_1.formatDates(startDate, endDateHidden ? null : endDate, timeZoneId, false, fullLocale, showTimeZone);
};
exports.getDaysToEvent = function (event) {
    var days = 0;
    var HOURS_PER_DAY = 24;
    if (!exports.isDateTbd(event)) {
        var start = formatter_1.getMomentDate(event.scheduling.config.startDate, event.scheduling.config.timeZoneId);
        var hours = Math.floor(formatter_1.getDiffInHours(start, formatter_1.now(event.scheduling.config.timeZoneId)));
        days = Math.ceil((hours - start.hour()) / HOURS_PER_DAY);
    }
    return days < 0 ? 0 : days;
};
